/**
 * Lobby Card Descriptors for Poker Reborn
 *
 * The ordered list of cards displayed in the lobby TapperScroller.
 * Each entry becomes a visual card. The system is extensible — add new
 * entries (promo, jump-to-game, etc.) to show more cards in the lobby.
 *
 * @see src/config/managers.ts - Manager data for game-type cards
 * @see src/screens/LobbyScreen.ts - Renders these cards
 */

import type { GameType } from '@/config/managers';

// =============================================================================
// TYPES
// =============================================================================

/** Card types supported in the lobby */
export type LobbyCardType = 'game' | 'promo' | 'jump';

/** Descriptor for a single lobby card */
export interface LobbyCardDescriptor {
  /** Unique card identifier */
  readonly id: string;
  /** What kind of card this is */
  readonly type: LobbyCardType;
  /** Card title (displayed on the card) */
  readonly title: string;
  /** Card subtitle (displayed below the title) */
  readonly subtitle: string;
  /** Game type — required for type: 'game' cards */
  readonly gameType?: GameType;
}

// =============================================================================
// CARD LIST
// =============================================================================

/**
 * The ordered list of cards shown in the lobby.
 * Add entries here to show new cards. The lobby renders them left-to-right.
 */
export const LOBBY_CARDS: readonly LobbyCardDescriptor[] = [
  {
    id: 'cash',
    type: 'game',
    title: 'CASH GAMES',
    subtitle: "No-Limit Hold'em",
    gameType: 'cash',
  },
  {
    id: 'fastfold',
    type: 'game',
    title: 'FAST-FOLD',
    subtitle: 'Speed Poker',
    gameType: 'fastfold',
  },
  {
    id: 'sng',
    type: 'game',
    title: 'SIT & GO',
    subtitle: 'Tournament',
    gameType: 'sng',
  },
];
